import React, { useEffect, useRef, useState } from 'react';
import RootOfStages from '../RootOfStages';
import FilterContainer from '../../containers/FilterContainerNew';
import './dashboard.scss';
import NotFound from '../../assets/0-items.png';
import funcTranslateHelper from '../../i18next/funcTranslateHelper';
import { PubSub, Auth } from 'aws-amplify';
import Alert from '@material-ui/lab/Alert';
import { Snackbar } from '@material-ui/core';
import { getAssets, sendMessageNotification, handleUserSession } from '../../actions';
import { useDispatch } from 'react-redux';

function Dashboard ({
  configFile,
  userRol,
  assets,
  setAssets,
  filters,
  filteredAssets
}) {
  const ref = useRef(null);

  const [notification, setNotification] = useState(null);

  const [notificationOpen, setNotificationOpen] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    const myUseEffect = async () => {
      await handleUserSession();

      var subUser;
      Auth.currentUserInfo({
        bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
      })
        .then(user => {
          sendMessageNotification(user.username + funcTranslateHelper('HAS_LOGGED'));

          // subscription by user
          subUser = PubSub.subscribe(configFile.name + user.username, { provider: 'AWSIoTProvider' }).subscribe({
            next: data => {
              data = data.value;
              if (data.type === 'NOTIFICATION') {
                setNotification(data);
                setNotificationOpen(true);
              }
            },
            error: error => console.error(error)
            // close: () => console.log('Done'),
          });
        });

      // subscription by app
      const sub = PubSub.subscribe(configFile.name, { provider: 'AWSIoTProvider' }).subscribe({
        next: data => {
          data = data.value;
          if (data.type === 'NOTIFICATION') {
            setNotification(data);
            setNotificationOpen(true);
          } else if (data.type === 'UPDATE_ASSET') {
            setNotification({ message: funcTranslateHelper('UPDATE_ASSET') + data.data.name });
            setNotificationOpen(true);
            if (!configFile.manualUpdate) {
              dispatch(getAssets());
            }
          } else if (data.type === 'ADD_ASSET') {
            setNotification({ message: funcTranslateHelper('ADD_ASSET') + data.data.name });
            setNotificationOpen(true);
            if (!configFile.manualUpdate) {
              dispatch(getAssets());
            }
          }
        },
        error: error => console.error(error)
        // close: () => console.log( 'Done' ),
      });

      // subscription by role
      const subRol = PubSub.subscribe(configFile.name + userRol, { provider: 'AWSIoTProvider' }).subscribe({
        next: data => {
          data = data.value;
          if (data.type === 'NOTIFICATION') {
            setNotification(data);
            setNotificationOpen(true);
          }
        },
        error: error => console.error(error)
        // close: () => console.log( 'Done' ),
      });
      return () => { subRol.unsubscribe(); subUser.unsubscribe(); sub.unsubscribe(); };
    };

    myUseEffect();
  }, [configFile, dispatch, userRol]);

  return (
    <div ref={ref} className='main-content'>
      {notification && (
        <Snackbar style={{ zIndex: '1000' }} open={notificationOpen} autoHideDuration={6000} onClose={() => setNotificationOpen(false)}>
          <Alert severity={notification.severity ? notification.severity : 'info'}>{notification.message}</Alert>
        </Snackbar>
      )}
      <FilterContainer />
      {assets && assets.length > 0 && filteredAssets && !filteredAssets.length ? (
        <div ref={ref} className='box-not-found'>
          <div className='content-not-found'>
            <img
              src={NotFound}
              className='img-not-found'
              alt='Items not found'
              width='40%'
            />
            <p className='txt-not-found'>
              {funcTranslateHelper('notResult')}
            </p>
          </div>
        </div>
      ) : (
        <div className='bx--row dashboard-box'>
          {configFile.stages.map((stage, i) => (
            <div className='bx--col column-mw' key={i}>
              <RootOfStages
                key={i}
                stages={stage}
                userRol={userRol}
                assets={assets}
                setAssets={setAssets}
                configFile={configFile}
                filters={filters}
                filteredAssets={filteredAssets}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Dashboard;
